import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { MechanismSection } from './components/MechanismSection';
import { IncludesSection } from './components/IncludesSection';
import { ForWhomSection } from './components/ForWhomSection';
import { ExpectationsSection } from './components/ExpectationsSection';
import { ObjectionSection } from './components/ObjectionSection';
import { PricingSection } from './components/PricingSection';
import { FinalClose } from './components/FinalClose';
import { SectionDivider } from './components/SectionDivider';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <main className="min-h-screen w-full overflow-x-hidden selection:bg-gold/30 selection:text-bark" data-id="element-0">
      <Hero data-id="element-1" />
      <SectionDivider data-id="element-2" />

      <PainSection data-id="element-3" />
      <SectionDivider data-id="element-4" />

      <TruthSection data-id="element-5" />
      <SectionDivider data-id="element-6" />

      <MechanismSection data-id="element-7" />
      <SectionDivider data-id="element-8" />

      <IncludesSection data-id="element-9" />
      <SectionDivider data-id="element-10" />

      <ForWhomSection data-id="element-11" />
      <SectionDivider data-id="element-12" />

      <ExpectationsSection data-id="element-13" />
      <SectionDivider data-id="element-14" />

      <ObjectionSection data-id="element-15" />
      <SectionDivider data-id="element-16" />

      <PricingSection data-id="element-17" />
      <SectionDivider data-id="element-18" />

      <FinalClose data-id="element-19" />
    </main>;
}